import {convertToUrlParams} from 'utils'
import baseApi, {provideTag} from './baseApi'

const accountsApi = baseApi.injectEndpoints({
    endpoints: (build) => ({
        getAccounts: build.query({
            query: (query) => {
                const params = convertToUrlParams(query)
                return {
                    url: `accounts${params}`,
                    method: 'GET',
                }
            },
            transformResponse: (res) => res,
            providesTags: (result) => provideTag('Account', result),
        }),
        deleteAccount: build.mutation({
            query: (id) => {
                return {
                    url: `accounts/${id}`,
                    method: 'DELETE',
                }
            },
            transformResponse: (res) => res,
            invalidatesTags: ['Account'],
        }),
        createAccount: build.mutation({
            query: (data) => {
                console.log('create account mutation req', {data})
                return {
                    url: `accounts`,
                    method: 'POST',
                    body: data,
                }
            },
            transformResponse: (res) => res,
            invalidatesTags: ['Account', 'UserAccounts'],
        }),
        editAccount: build.mutation({
            query: (data) => {
                return {
                    url: `accounts/${data._id}`,
                    method: 'PUT',
                    body: data,
                }
            },
            transformResponse: (res) => res,
            invalidatesTags: ['Account'],
        }),
        getAccount: build.query({
            query: (id) => {
                return {
                    url: `accounts/${id}`,
                    method: 'GET',
                }
            },
            transformResponse: (res) => res,
            providesTags: (result) => provideTag('Account', result),
        }),
    }),
    overrideExisting: false,
})

export default accountsApi

export const {
    useGetAccountsQuery,
    useGetAccountQuery,
    useDeleteAccountMutation,
    useCreateAccountMutation,
    useEditAccountMutation,
} = accountsApi
